import Box from "@material-ui/core/Box"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Radio from "@material-ui/core/Radio"
import Typography from "@material-ui/core/Typography"
import { HourReportWorkflow } from "../../api"
import { useHourReportWorkflowTranslations } from "./use-translations"

type ReportingOnlyWorkflowProps = {
  disabled: boolean
}

const ReportingOnlyWorkflow = ({ disabled }: ReportingOnlyWorkflowProps) => {
  const translations = useHourReportWorkflowTranslations()

  return (
    <FormControlLabel
      value={HourReportWorkflow.ReportingOnly}
      disabled={disabled}
      control={<Radio color="primary" style={{ marginRight: 12, marginTop: -12 }} />}
      label={
        <Box py={0.5}>
          <Typography variant="subtitle1">{translations.reportingOnlyLabel}</Typography>
          <Typography variant="body2" color="textSecondary">
            {translations.reportingOnlyDescription}
          </Typography>
        </Box>
      }
    />
  )
}

export default ReportingOnlyWorkflow
